// ----------------------------------- Actions ---------------------------------

import { type UnknownAction } from '@reduxjs/toolkit';

// Action Types
enum CommonAction {
  SHOW_MESSAGE = 'common/show_message',
  HIDE_MESSAGE = 'common/hide_message',
  SHOW_SNACKBAR_MESSAGE = 'common/show_snackbar_message',
  OPEN_DRAWER = 'common/open_drawer',
  CLOSE_DRAWER = 'common/close_drawer',
  OPEN_NOTIFICATIONS = 'common/open_notifications',
  CLOSE_NOTIFICATIONS = 'common/close_notifications',
  CHANGE_PAGE = 'common/change_page',
}

// Action Creators
export const showMessage = (message: string) => ({
  type: CommonAction.SHOW_MESSAGE,
  payload: message,
});
export const hideMessage = () => ({ type: CommonAction.HIDE_MESSAGE });
export const showSnackbarMessage = (message: string | null) => ({
  type: CommonAction.SHOW_SNACKBAR_MESSAGE,
  payload: message,
});
export const openDrawer = () => ({ type: CommonAction.OPEN_DRAWER });
export const closeDrawer = () => ({ type: CommonAction.CLOSE_DRAWER });
export const openNotifications = () => ({
  type: CommonAction.OPEN_NOTIFICATIONS,
});
export const closeNotifications = () => ({
  type: CommonAction.CLOSE_NOTIFICATIONS,
});

interface CommonState {
  snackbarMessage: string;
  drawerOpen: boolean;
  message: {
    type: string;
    text: string | undefined;
  };
  open: boolean;
  notificationsOpen: boolean;
}

// Init State
const INIT_STATE: CommonState = {
  snackbarMessage: '',
  drawerOpen: false,
  message: {
    type: 'success',
    text: undefined,
  },
  open: false,
  notificationsOpen: false,
};

// ----------------------------------- Reducer ---------------------------------
// Reducer
const commonReducer = (state = INIT_STATE, action: UnknownAction): CommonState => {
  const { type, payload } = action;
  switch (type) {
    case CommonAction.OPEN_NOTIFICATIONS:
      return {
        ...state,
        notificationsOpen: true,
      };
    case CommonAction.CLOSE_NOTIFICATIONS:
      return {
        ...state,
        notificationsOpen: false,
      };
    case CommonAction.SHOW_SNACKBAR_MESSAGE: {
      return {
        ...state,
        snackbarMessage: payload as string,
      };
    }
    case CommonAction.HIDE_MESSAGE: {
      return {
        ...state,
        message: { ...state.message, text: undefined },
        open: false,
      };
    }
    case CommonAction.OPEN_DRAWER: {
      return {
        ...state,
        drawerOpen: true,
      };
    }
    case CommonAction.CLOSE_DRAWER: {
      return {
        ...state,
        drawerOpen: false,
      };
    }
    default:
      return state;
  }
};

export default commonReducer;
